<script setup lang="ts">
import { useThrottleFn } from '@vueuse/core';
import HeaderLogo from './common/HeaderLogo.vue';
import HeaderDesktop from './desktop/HeaderDesktop.vue';
import HeaderMobile from './mobile/HeaderMobile.vue';
import HeaderPlugins from './common/HeaderPlugins.vue';

const isScrolled = ref(false);

onMounted(() => {
  if (window) {
    handleOnScroll();
    document.addEventListener('scroll', handleOnScroll, { passive: true });
  }
});

onBeforeUnmount(() => {
  if (window) {
    document.removeEventListener('scroll', handleOnScroll);
  }
});

const handleOnScroll = useThrottleFn(() => {
  const rect = window.scrollY;
  isScrolled.value = rect > 10;
}, 10);
</script>

<template>
  <header class="header container">
    <div
      class="header-wrapper"
      :class="{ header_shadow: isScrolled }"
    ></div>

    <div class="header-content">
      <HeaderLogo />
      <HeaderDesktop v-if="$device.isDesktop" />
      <HeaderMobile v-else />
    </div>
  </header>

  <client-only>
    <HeaderPlugins />
  </client-only>

  <AuthModal />
</template>

<style scoped lang="scss">
@import '../../assets/variables';

.header {
  position: fixed;
  top: 16px;
  left: 50vw;
  translate: -50%;
  z-index: 1000;
  width: 100%;
  min-height: 56px;
  background-color: white;
  border-radius: 16px;

  .header-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    pointer-events: none;
    border-radius: 16px;
    transition: box-shadow 0.2s ease-in-out;
    box-shadow: 0 4px 40px transparent;

    &.header_shadow {
      box-shadow: 0 4px 40px #00000017;
    }
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 8px 16px;
    width: 100%;
  }

  @include media-breakpoint-down(md) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    top: 0;
  }
}
</style>
